import styled from '@emotion/styled';
import React, { useContext, useEffect, useState } from 'react';
import { CartContext } from '../../Context/CartContext';
import { AddIcon, MinusIcon } from '../../svg';

const StyledVoucherAccordian = styled.div`
	.accordian {
		max-height: 66px;
		overflow: hidden;
		transition: max-height 0.5s cubic-bezier(0, 1, 0, 1) 0.4s;

		&__heading {
			background: #f3f3f3;
			color: #212121;
		}
		&__content {
			transform: translateX(-20px);
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s ease-in-out;
			border: 1px solid #e3e3e3;
		}
		&.active {
			max-height: 9999px !important;
			transition: max-height 0.5s ease-in-out 0.2s;

			.accordian__content {
				transform: none;
				opacity: 1;
				visibility: visible;
				transition: all 0.3s ease-in-out 0.4s;
			}
		}
	}

	.alert-success {
		border: 1px solid #117b53;
	}
`;

function VoucherAccordian({ children, title }) {
	const { couponCode, velocityNumber } = useContext(CartContext);
	const [showPromoInput, setShowPromoInput] = useState(false);

	const toogleShowPromoInput = () => {
		setShowPromoInput(!showPromoInput);
	};

	useEffect(() => {
		if (couponCode || velocityNumber) {
			toogleShowPromoInput();
		}
	}, []);

	return (
		<StyledVoucherAccordian className='mb-40'>
			<div className={`accordian ${showPromoInput ? 'active' : ''}`}>
				<div
					className='accordian__heading font-weight-bold p-20 d-flex justify-content-between align-items-center cursor-pointer'
					onClick={toogleShowPromoInput}
				>
					{title}
					{showPromoInput ? <MinusIcon /> : <AddIcon />}
				</div>
				<div className='accordian__content p-20'>{children}</div>
			</div>
		</StyledVoucherAccordian>
	);
}

export default VoucherAccordian;
